const messageReducer = (state, action) => {
  switch (action.type) {
    case 'MESSAGE_LIST_LOAD':
      return {
        ...state,
        messageListProgress: true,
        messageList: [],
        messageListIsOld: false,
        messageListTotal: 0,
      };
    case 'MESSAGE_LIST_UPDATE':
      return { ...state, messageListProgress: true, messageListIsOld: false };
    case 'MESSAGE_LIST_SUCCESS':
      return {
        ...state,
        messageListProgress: false,
        messageListLoaded: true,
        messageList: [...state.messageList, ...action.messageList],
        messageListTotal: action.messageListTotal,
        messageListOffset: action.messageListOffset,
        messageListLimit: action.messageListLimit,
      };
    case 'MESSAGE_LIST_RESET':
      return {
        ...state,
        messageListProgress: false,
        messageList: state.messageList.slice(0, 60),
        messageListOffset: 60,
      };
    case 'MESSAGE_LIST_ERROR':
      return {
        ...state,
        messageListProgress: false,
        messageListLoaded: true,
        messageListError: action.error,
      };
    case 'MESSAGE_MODERATOR_NEW':
      return { ...state, messageList: [action.post, ...state.messageList] };
    case 'MESSAGE_NEW': {
      const withoutTempMessages = state.messageList.filter(
        (msg) => !msg.hasOwnProperty('tempText')
      );
      // Avoid duplicate if message already exists (e.g. optimistic update)
      const exists = withoutTempMessages.some((m) => m.id === action.post.id);
      if (exists) return state;

      const merged = [action.post, ...withoutTempMessages];
      // Sort by sent timestamp DESC (newest first) - fixes ordering when
      // Pusher delivers messages out of order (e.g. own message arrives after others')
      merged.sort((a, b) => new Date(b.sent || 0) - new Date(a.sent || 0));
      return {
        ...state,
        messageList: merged.slice(0, 60),
        messageListTotal: state.messageListTotal + 1,
      };
    }
    case 'MESSAGE_MODERATE_SUCCESS': {
      let newMessageList = [...state.messageList];
      var foundIndex = newMessageList.findIndex(
        (item) => item.id === action.post.id
      );
      newMessageList[foundIndex] = action.post;
      return { ...state, messageList: newMessageList };
    }
    case 'MESSAGE_POST_LOAD':
      return {
        ...state,
        messagePostProgress: true,
        messagePostError: null,
        messageList: [
          { tempText: action.post.text },
          ...state.messageList,
        ].slice(0, 60),
      };
    case 'MESSAGE_POST_SUCCESS':
      return {
        ...state,
        messagePostProgress: false,
        messagePostSuccess: true,
        messagePost: action.post,
        messagePostError: null,
        messageListIsOld: true,
        messageList: state.messageList.slice(0, 60),
      };
    case 'MESSAGE_POST_ERROR':
      return {
        ...state,
        messagePostProgress: false,
        messagePostSuccess: false,
        messagePostError: action.error,
      };
    default:
      return state;
  }
};

export default messageReducer;
